<template>
  <edit-text :value="data[propName]" :handler="columnEdit ? update : undefined" />
</template>

<script lang="ts" setup>
import { defineProps } from 'vue';
import { TextFieldType } from '@/components/business/crud/interface/FieldType';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';
import EditText from '@/components/business/crud/common/EditText.vue';
import { ColumnEdit } from '@/components/business/crud/widgets/TableWidgetContainer';

const props = defineProps<{
  columnEdit?: ColumnEdit;
  propName: string;
  widget: TextFieldType;
  info: WidgetInfo;
  data: any;
}>();

async function update(value: string) {
  if (!props.columnEdit) {
    return true
  }
  return props.columnEdit(props.data, props.propName, value);
}
</script>

<style lang="scss" scoped>
.show {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}
</style>
